export default __webpack_public_path__ + "static/media/icon-price-perception.56787567.svg";